import { render, staticRenderFns } from "./ReceiptUpload.vue?vue&type=template&id=0efc6b7d&scoped=true"
import script from "./ReceiptUpload.vue?vue&type=script&lang=ts"
export * from "./ReceiptUpload.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptUpload.vue?vue&type=style&index=0&id=0efc6b7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc6b7d",
  null
  
)

export default component.exports